import { render } from "./SlideEditor.vue?vue&type=template&id=73ac6948&scoped=true"
import script from "./SlideEditor.vue?vue&type=script&lang=js"
export * from "./SlideEditor.vue?vue&type=script&lang=js"

import "./SlideEditor.vue?vue&type=style&index=0&id=73ac6948&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ac6948"]])

export default __exports__